import { createTheme } from "@mantine/core";
import "@mantine/core/styles.css";

export const theme = createTheme({
  fontFamily: "Albert Sans",
  colors: {
    // @ts-ignore
    darkBlue: ["#2c1561"],
    // @ts-ignore
    darkPurple: ["#4b1d70"],
    // @ts-ignore
    mauve: ["#eeddf7"]
  }
});
